'use strict';
import * as $j_app$002edata$002e$002dApp$002dAuth$002dData$0024 from "./app.data.-App-Auth-Data$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_auth_OperationalUserWithClient$Pharmacy$Raw(client, server) {
  this.Lapp_auth_OperationalUserWithClient$Pharmacy$Raw__f_client = null;
  this.Lapp_auth_OperationalUserWithClient$Pharmacy$Raw__f_server = null;
  this.Lapp_auth_OperationalUserWithClient$Pharmacy$Raw__f_client = client;
  this.Lapp_auth_OperationalUserWithClient$Pharmacy$Raw__f_server = server;
}
export { $c_Lapp_auth_OperationalUserWithClient$Pharmacy$Raw as $c_Lapp_auth_OperationalUserWithClient$Pharmacy$Raw };
$c_Lapp_auth_OperationalUserWithClient$Pharmacy$Raw.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_auth_OperationalUserWithClient$Pharmacy$Raw.prototype.constructor = $c_Lapp_auth_OperationalUserWithClient$Pharmacy$Raw;
/** @constructor */
function $h_Lapp_auth_OperationalUserWithClient$Pharmacy$Raw() {
}
export { $h_Lapp_auth_OperationalUserWithClient$Pharmacy$Raw as $h_Lapp_auth_OperationalUserWithClient$Pharmacy$Raw };
$h_Lapp_auth_OperationalUserWithClient$Pharmacy$Raw.prototype = $c_Lapp_auth_OperationalUserWithClient$Pharmacy$Raw.prototype;
$c_Lapp_auth_OperationalUserWithClient$Pharmacy$Raw.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_auth_OperationalUserWithClient$Pharmacy$Raw.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1842487681, true);
});
$c_Lapp_auth_OperationalUserWithClient$Pharmacy$Raw.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_auth_OperationalUserWithClient$Pharmacy$Raw)) {
    var x = this.Lapp_auth_OperationalUserWithClient$Pharmacy$Raw__f_client;
    var x$2 = x$0.Lapp_auth_OperationalUserWithClient$Pharmacy$Raw__f_client;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lapp_auth_OperationalUserWithClient$Pharmacy$Raw__f_server;
      var x$4 = x$0.Lapp_auth_OperationalUserWithClient$Pharmacy$Raw__f_server;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lapp_auth_OperationalUserWithClient$Pharmacy$Raw.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_auth_OperationalUserWithClient$Pharmacy$Raw.prototype.productArity__I = (function() {
  return 2;
});
$c_Lapp_auth_OperationalUserWithClient$Pharmacy$Raw.prototype.productPrefix__T = (function() {
  return "Raw";
});
$c_Lapp_auth_OperationalUserWithClient$Pharmacy$Raw.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_auth_OperationalUserWithClient$Pharmacy$Raw__f_client;
  }
  if ((n === 1)) {
    return this.Lapp_auth_OperationalUserWithClient$Pharmacy$Raw__f_server;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_auth_OperationalUserWithClient$Pharmacy$Raw.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "client";
  }
  if ((n === 1)) {
    return "server";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_auth_OperationalUserWithClient$Pharmacy$Raw.prototype.server__Lapp_data_OperationalAppRegisteredUser$Pharmacy = (function() {
  return this.Lapp_auth_OperationalUserWithClient$Pharmacy$Raw__f_server;
});
$c_Lapp_auth_OperationalUserWithClient$Pharmacy$Raw.prototype.authData__Lcom_raquo_airstream_core_Signal = (function() {
  return this.Lapp_auth_OperationalUserWithClient$Pharmacy$Raw__f_client.authData__Lcom_raquo_airstream_core_Signal();
});
$c_Lapp_auth_OperationalUserWithClient$Pharmacy$Raw.prototype.authDataCodec__Lsttp_tapir_Codec = (function() {
  return $j_app$002edata$002e$002dApp$002dAuth$002dData$0024.$m_Lapp_data_AppAuthData$().pharmacyCodec__Lsttp_tapir_Codec();
});
$c_Lapp_auth_OperationalUserWithClient$Pharmacy$Raw.prototype.client__Lapp_auth_ClientSideAuthUser = (function() {
  return this.Lapp_auth_OperationalUserWithClient$Pharmacy$Raw__f_client;
});
$c_Lapp_auth_OperationalUserWithClient$Pharmacy$Raw.prototype.server__Lapp_data_OperationalAppRegisteredUser = (function() {
  return this.Lapp_auth_OperationalUserWithClient$Pharmacy$Raw__f_server;
});
function $isArrayOf_Lapp_auth_OperationalUserWithClient$Pharmacy$Raw(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_auth_OperationalUserWithClient$Pharmacy$Raw)));
}
export { $isArrayOf_Lapp_auth_OperationalUserWithClient$Pharmacy$Raw as $isArrayOf_Lapp_auth_OperationalUserWithClient$Pharmacy$Raw };
var $d_Lapp_auth_OperationalUserWithClient$Pharmacy$Raw = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_auth_OperationalUserWithClient$Pharmacy$Raw, "app.auth.OperationalUserWithClient$Pharmacy$Raw", ({
  Lapp_auth_OperationalUserWithClient$Pharmacy$Raw: 1,
  Lapp_auth_HasAuthData: 1,
  Lapp_auth_OperationalUserWithClient: 1,
  Lapp_auth_OperationalUserWithClient$Pharmacy: 1,
  Lapp_auth_OperationalUserWithClient$Raw: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_auth_OperationalUserWithClient$Pharmacy$Raw as $d_Lapp_auth_OperationalUserWithClient$Pharmacy$Raw };
//# sourceMappingURL=app.auth.-Operational-User-With-Client$-Pharmacy$-Raw.js.map
